<template>
  <div>
    <ViewTemplateWithTable :panel="panel" :templateList="templateList" :actions="actions" :filters="filters">
      <div slot="content-buttons">
        <Button _key="btnNfseCreate" title="NFSe" classIcon="fas fa-plus-circle" type="primary" size="small"
          eventName="nfsePrefeituraCreate" :clicked="create" />
        <div>
        </div>
      </div>
    </ViewTemplateWithTable>
  </div>
</template>

<script>
import ViewTemplateWithTable from "@nixweb/nixloc-ui/src/component/template/ViewTemplateWithTable.vue";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import { mapGetters, mapMutations, mapActions, mapState } from "vuex";

export default {
  name: "NfsePrefeituraListView",
  components: {
    ViewTemplateWithTable,
    Button,
  },
  data() {
    return {
      id: "",
      panel: {
        module: "Nota Fiscal",
        title: "NFSe Prefeitura",
        showFilter: true,
        showSearch: true,
        showButtons: true,
      },
      templateList: {
        urlGetApi: "/api/v1/tax-document/nfse-prefeitura/get-all",
        showChecks: true,
        headerTable: [
          {
            title: "Número",
            field: "numero",
            type: "text",
            iconSearch: false,
          },
          {
            title: "Emissão",
            field: "registeredDate",
            type: "dateTime",
            iconSearch: false,
            classCssTitle: "text-center",
            classCssBody: "text-center",
          },
          {
            field: "cliente",
            title: "Cliente",
            type: "link",
            routeName: "nfsePrefeituraUpdate",
            iconSearch: true,
          },
          {
            field: "statusNome",
            title: "Status",
            type: "class",
            fieldComparison: "statusNome",
            classCssTitle: "text-center",
            classCssBody: [
              {
                classCss: "text-center badge badge-warning",
                fieldComparison: "Pendente",
              },
              {
                classCss: "text-center badge badge-info",
                fieldComparison: "Em processamento",
              },
              {
                classCss: "text-center badge badge-success",
                fieldComparison: "Autorizada",
              },
              {
                classCss: "text-center badge badge-success",
                fieldComparison: "Concluída",
              },
              {
                classCss: "text-center badge badge-danger",
                fieldComparison: "Cancelada",
              },
              {
                classCss: "text-center badge badge-danger",
                fieldComparison: "Rejeitada",
              },
              {
                classCss: "text-center badge badge-danger",
                fieldComparison: "Falha",
              },
            ],
          },
          {
            title: "Nota",
            field: "valorNota",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            type: "currency",
          },
          {
            title: "Impostos Aprox...",
            field: "valorImposto",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            type: "currency",
          },
          {
            title: "Final",
            field: "valorFinal",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            type: "currency",
          },
        ],
      },
      actions: [
        { type: "delete", title: "Remover", description: "Remover", url: "/api/v1/tax-document/nfse-prefeitura/delete", method: "delete" },
      ],
      filters: [
        {
          type: "date",
          title: "Data Emissão",
          field: "RegisteredDate",
          value: "",
        },
        {
          type: "options",
          title: "Status",
          field: "StatusName",
          options: [
            { text: "Autorizada", value: "Autorizada" },
            { text: "Pendente", value: "Pendente" },
            { text: "Em processamento", value: "Em processamento" },
            { text: "Rejeitada", value: "Rejeitada" },
            { text: "Cancelada", value: "Cancelada" },
          ],
          value: [],
        },
        {
          type: "decimal",
          title: "Valor",
          field: "ValueFinal",
          valueStart: 0,
          valueEnd: 0,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
    ...mapState("generic", ["selected"]),
    ...mapState("user", ["userLogged"]),
    hasRemove() {
      if (this.userLogged.user.userName == 'UserTemp') return true;
      return false;
    }
  },
  methods: {
    ...mapMutations("generic", ["openModal", "hideModal", "removeLoading"]),
    ...mapActions("generic", ["deleteAllApi"]),
    create() {
      this.$router.push({
        name: "nfsePrefeituraCreate",
      });
      this.removeLoading(["btnNfseCreate"]);
    },
  },
};
</script>
<style>
.fa-thumbs-up {
  color: #15A34A;
}

.fa-thumbs-down {
  color: #DC2626;
}

.nfse-progress {
  color: #577696;
  border: 1px solid #bee2f8 !important;
  background-color: #F2F9FE;
}

.nfse-accepted {
  background: #F5FEFA;
  border: 1px solid #a7f3d0 !important;
  color: #065f46;
}

.nfse-rejected {
  background: #FFF8F8;
  border: 1px solid #fecaca !important;
  color: #b91c1c;
}
</style>